<template lang="pug">
div.analytic.charts
  Toolbar(toolbarTitle="Аналитика")
  .content.overflow-visible.max-height-initial
    .charts__items
      .charts__item(v-if="hasChartProduction" :class="hasChartHigh ? 'charts__item__high' : ''")
        chart-garbage-production(:limit="hasChartHigh ? null : 25")
      .charts__item(v-if="hasChartDynamic" )
        chart-dynamic
      .charts__item(v-if='hasChartGarbageCalculation' )
        chart-garbage-calculation(:limit="25")
      .charts__item(v-if='hasChartGarbageKp' )
        chart-garbage-kp(:limit="25")
      .charts__item.charts__item_operator-expenses(v-if='hasOperatorExpenses')
        operator-expenses
      .charts__item(v-if='hasMsnGraph')
        msn-delta
      .charts__item(v-if='hasChartForms')
        chart-form-one
      .charts__item(v-if='hasChartForms')
        chart-form-two
      .charts__item(v-if='hasChartForms')
        chart-generated-tko
</template>
<script>
import hasMixin from '@/mixins/has-mixin'
import Toolbar from './components/toolbar'
import chartsMixin from './mixins/charts-mixin'
import ChartDynamic from './components/chart-dynamic'
import ChartGarbageProduction from './components/chart-garbage-production'
import ChartMsn from './components/chart-msn'
import ChartMsnContainer from './components/chart-msn-container'
import ChartGarbageCalculation from './components/chart-garbage-calculation'
import ChartGarbageKp from './components/chart-garbage-kp'
import OperatorExpenses from './components/operator-expenses'
import MsnDelta from './components/msn-delta'
import ChartFormOne from './components/chart-form-one'
import ChartFormTwo from './components/chart-form-two'
import ChartGeneratedTko from './components/chart-generated-tko'

export default {
  components: {
    ChartMsnContainer,
    ChartMsn,
    ChartGarbageProduction,
    ChartGarbageCalculation,
    ChartGarbageKp,
    ChartDynamic,
    Toolbar,
    OperatorExpenses,
    MsnDelta,
    ChartFormOne,
    ChartFormTwo,
    ChartGeneratedTko,
  },
  mixins: [chartsMixin, hasMixin],
  title: null,
}
</script>
